import { Clear } from '@mui/icons-material'
import { Grid, Box, Button, CardActions, Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography, useMediaQuery } from '@mui/material'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { ROLES } from 'src/constants'

export default function StatusHistoryDialog({ open, onClose, statusHistory }) {
    const { t } = useTranslation()

    const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            fullScreen={fullScreen}
            open={open}
            aria-labelledby="guard-dialog-title"
            disableScrollLock
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {t('Track Status History')}
                <IconButton onClick={() => onClose(false)} color="primary">
                    <Clear />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                {/* {!statusHistory &&
                    <Typography textAlign="center" fontWeight="bold">
                        {t("No data found.")}
                    </Typography>
                } */}
                <Grid container spacing={2}>
                    <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                            {t("Status")}
                        </Typography>
                        <Typography variant="h6">
                            {t(statusHistory?.status)}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                            {t("Date")}
                        </Typography>
                        <Typography variant="h6">
                            {moment(statusHistory?.dateTime).format("DD/MM/YYYY - hh:mm a")}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Box display="flex" alignItems="center">
                            <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                {t("Change by")}
                            </Typography>
                            {!!statusHistory?.userType &&
                                <Typography variant="h6">
                                    {t(`userType.${statusHistory?.userType}`)}
                                </Typography>
                            }
                        </Box>
                        {
                            statusHistory?.userType !== "Customer" &&
                            <Box pl={2} mt={1}>
                                {!!statusHistory?.by?.role &&
                                    <Box display="flex" alignItems="center">
                                        <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                            {t("User role")}
                                        </Typography>
                                        <Typography variant='subtitle1' fontWeight="bold">
                                            {t(`USER_ROLES.${statusHistory?.by?.role}`)}
                                        </Typography>
                                    </Box>
                                }
                                {
                                    !!statusHistory?.by?.name &&
                                    <Box display="flex" alignItems="center">
                                        <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                            {t("Name")}
                                        </Typography>
                                        <Typography variant='subtitle1' fontWeight="bold">
                                            {statusHistory?.by?.name}
                                        </Typography>
                                    </Box>
                                }
                                {
                                    (!!statusHistory?.by?.phone || !!statusHistory?.by?.email) &&
                                    <Box display="flex" alignItems="center">
                                        <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                            {statusHistory?.by?.role === ROLES.driver ? t("Phone") : t("Email")}
                                        </Typography>
                                        <Typography variant='subtitle1' fontWeight="bold">
                                            <bdi>
                                                {statusHistory?.by?.role === ROLES.driver ? statusHistory?.by?.phone : statusHistory?.by?.email}
                                            </bdi>
                                        </Typography>
                                    </Box>
                                }
                            </Box>
                        }
                    </Grid>
                    {
                        !!statusHistory?.driver &&
                        <Grid item xs={6}>
                            <Typography fontWeight="bold" sx={{ mr: 1.5 }} color="text.lighter" variant='body2'>
                                {t("Driver")}
                            </Typography>
                            <Typography>{t(statusHistory?.driver?.name)}</Typography>
                            <Typography>{t(statusHistory?.driver?.phone)}</Typography>
                        </Grid>
                    }

                </Grid>
            </DialogContent>
            <Divider />
            <CardActions>
                <Button onClick={() => onClose()} color="primary" variant="contained" sx={{ textTransform: "none" }}>
                    {t('Close')}
                </Button>
            </CardActions>
        </Dialog>
    )
}
